import styles from './styles.module.css';
import { Icon } from '../index';
import { Icons } from '../Icon/Icon';

interface DeleteButtonProps {
    onClick: () => void;
    size?: 'sm';
}

const DeleteButton = ({ onClick, size }: DeleteButtonProps) => {
    return (
        <button className={`${styles.btn} ${size ? styles[size] : ''}`} type={'button'} onClick={onClick}>
            <Icon icon={Icons.close} />
        </button>
    );
};

export default DeleteButton;
